<template>
  <div class="container">
    <div class="container__inner container__inner--min exhibition">
      <p class="contentTitle">函館展</p>
      <ul class="exhibition__cont detailTable">
        <li class="detailTable__item">
          <p class="detailTable__item__title">日程</p>
          <p class="detailTable__item__cont">2018年2月10(日) 〜 11日(月)</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">場所</p>
          <p class="detailTable__item__cont">五稜郭タワー 1F アトリウム</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">時間</p>
          <p class="detailTable__item__cont">10:00〜16:00</p>
        </li>
      </ul>

      <div class="exhibition__cont">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2974.5567637045324!2d140.75186301515095!3d41.79476507860457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f9ef46bb53c0eb3%3A0x75f5f82028f1a89e!2z5LqU56ic6YOt44K_44Ov44O8!5e0!3m2!1sja!2sjp!4v1549686657674"
          width="640"
          height="320"
          frameborder="0"
          allowfullscreen
          class="exhibition__cont__map"
        ></iframe>
      </div>
      <div class="exhibition__cont exhibition__cont--center">
        <router-link class="button" to="/hakodate">詳しく見る</router-link>
      </div>
    </div>

    <div class="container__inner container__inner--min exhibition">
      <p class="contentTitle">東京展</p>
      <ul class="exhibition__cont detailTable">
        <li class="detailTable__item">
          <p class="detailTable__item__title">日程</p>
          <p class="detailTable__item__cont">2018年2月17(日) 〜 18日(月)</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">場所</p>
          <p class="detailTable__item__cont">内田洋行 東京ユビキタス協創広場 CANVAS</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">時間</p>
          <p class="detailTable__item__cont">10:00〜16:00</p>
        </li>
      </ul>
      <div class="exhibition__cont">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.0346971050517!2d139.77789691497446!3d35.67614763785876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018895c5a647fd7%3A0xaa819cb9fd2e7aa9!2z77yI5qCq77yJ5YaF55Sw5rSL6KGMIOadseS6rOODpuODk-OCreOCv-OCueWNlOWJteW6g-WgtCBDQU5WQVM!5e0!3m2!1sja!2sjp!4v1549686713207"
          width="640"
          height="320"
          frameborder="0"
          allowfullscreen
          class="exhibition__cont__map"
        ></iframe>
      </div>
      <div class="exhibition__cont exhibition__cont--center">
        <router-link class="button" to="/tokyo">詳しく見る</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'o-exibitions'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Organisms/Exhibitions/index.vue